export default "__VITE_ASSET__BXtfJtWc__"